import { UNIVERSE_PATH } from '@/routes/gateway/gatewayPaths'

export const primaryPlayNavigation = [
  { id: 'home', path: '/home', accent: 'multi' },
  { id: 'hub', path: '/hub', accent: 'multi' },
  { id: 'strategy', path: '/strategy', accent: 'blue' },
  { id: 'puzzle', path: '/puzzle', accent: 'yellow' },
  { id: 'online', path: '/online', accent: 'green' },
  { id: 'arcade', path: '/arcade', accent: 'red' },
  { id: 'challenges', path: '/challenges', accent: 'red' },
  { id: 'ranking', path: '/ranking', accent: 'yellow' },
  { id: 'tools', path: '/tools', accent: 'blue' },
] as const

export const secondaryPlayNavigation = [
  { id: 'rules', path: '/rules' },
  { id: 'education', path: '/education' },
  { id: 'privacy', path: '/privacy' },
  { id: 'workshops', path: 'https://www.united-square.com/fr/ateliers' },
  { id: 'gateway', path: UNIVERSE_PATH },
] as const

export type PlayNavigationDestination =
  | (typeof primaryPlayNavigation)[number]
  | (typeof secondaryPlayNavigation)[number]

export type PlayNavigationId = PlayNavigationDestination['id']

export function isPlayNavigationActive(pathname: string, path: string) {
  return pathname === path || (path !== '/' && pathname.startsWith(`${path}/`))
}
